// extracted by mini-css-extract-plugin
export default {"container__table":"styles_container__table__B+l3k","container__source-badge":"styles_container__source-badge__B3KyV","container__footer":"styles_container__footer__bWleB"};